import { createAction, props } from '@ngrx/store';
import { BypassInformation, PigAccessory, PigAssociatedProduct, PigBulletin, PigComponent, PigQueryResult, ProductInformation, ReplacementPart } from '../../models';
import { LookupValue } from '../../models/lookup.model';

export const loadPigQueryResults = createAction('[Pig] Load Pigs Results');
export const loadPigQueryResultsSuccess = createAction('[Pig] Load Pigs Results Success', props<{ results: PigQueryResult[] }>());
export const loadPigQueryResultsFailure = createAction('[Pig] Load Pigs Results Failure', props<{ error: any }>());

export const loadPigLookups = createAction('[Pig] Load Pig Lookups', props<{ force?: boolean }>());
export const loadPigLookupsSuccess = createAction('[Pig] Load Pig Lookups Success', props<{
  data: {
    diameters: LookupValue[],
    pigEfficiencies: LookupValue[],
    pipelineServices: LookupValue[],
    pigPurposes: LookupValue[]
  }
}>());
export const loadPigLookupsFailure = createAction('[Pig] Load Pig Lookups Failure', props<{ error: any }>());

export const changePreviouslyPigged = createAction('[PIG] Change Previously Pigged', props<{ wasPreviouslyPigged: number }>());
export const changePipeSizeId = createAction('[PIG] change pipe size', props<{ pipeSizeId: number }>());
export const changePurposeId = createAction('[PIG] change purpose id', props<{ purposeId: number }>());
export const changeServiceId = createAction('[PIG] change service id', props<{ serviceId: number }>());
export const changeBidirectional = createAction('[PIG] change bidirectional', props<{ bidirectional: boolean }>());
export const changeEfficiency = createAction('[PIG] change efficiency', props<{ efficiency: number }>());
export const changeAggressiveness = createAction('[PIG] change aggressiveness', props<{ aggressiveness: number }>())

export const activatePig = createAction('[PIG] activate pig', props<{ id: number }>());

export const loadActivatedPigReferences = createAction('[PIG] load active pig refs');
export const loadActivatedPigReferencesSuccess = createAction('[PIG] load active pig refs success',
  props<{
    productInfo: ProductInformation[],
    bypassInfo: BypassInformation[],
    replacementParts: ReplacementPart[],
    components: PigComponent[],
    accessories: PigAccessory[],
    associatedProducts: PigAssociatedProduct[],
    bulletin: PigBulletin[]
  }>());
export const loadActivatedPigReferencesFail = createAction('[PIG] load active pig refs fail', props<{ error: any }>());


export const loadActivePigCutSheet = createAction('[Pig] Load active pig cut sheet');
export const loadActivePigCutSheetSuccess = createAction('[Pig] Load active pig cut sheet Results Success');
export const loadActivePigCutSheetFailure = createAction('[Pig] Load active pig cut sheet Results Failure', props<{ error: any }>());
